var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('command',{attrs:{"name":_vm.command}},[_c('div',{staticClass:"item"},[_c('icon',{attrs:{"type":_vm.iconType,"title":_vm.text}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }